/* eslint-disable */
window.addEventListener('load', () => {
  const btnclassname = document.getElementsByClassName('btn')[8]
  if (btnclassname) {
    btnclassname.addEventListener('click', () => {
      if (window.screen.width < 600) {
        window.scrollTo(0, 330)
      }
      if (window.screen.width === 320) {
        window.scrollTo(0, 390)
      }
      if (window.screen.width > 610) {
        window.scrollTo(0, 390)
      }
    })
  }
})

// cookie-banner-fix
window.addEventListener('load', () => {
  const hascookiebanner = document.getElementsByClassName('optanon-alert-box-wrapper')[0]  

  function cookieHeader() { // NOSONAR
    if (hascookiebanner !== null && hascookiebanner !== undefined) {      
      const bodyTag = document.getElementsByTagName('body')[0]
      const header = document.getElementsByClassName('header-wrapper')[0]
      const banner = document.getElementsByClassName('optanon-alert-box-wrapper')[0]

      if ((banner !== undefined && banner !== null) && (banner.style.display === '' || banner.style.display === 'block')) {
        if (banner.style.bottom === '') {
          bodyTag.classList.add('banner-adj')
          banner.classList.add('cookieban')
          bodyTag.style.top = `${banner.offsetHeight}px`
          header.style.top = `${banner.offsetHeight}px`
          clearInterval(setInt)
        } else {
          banner.style.display = 'block'
        }
      } else {
        bodyTag.classList.remove('banner-adj')
        bodyTag.style.top = `${0}px`
        header.style.top = `${0}px`
        clearInterval(setInt)
      }

      const close = document.getElementsByClassName('optanon-alert-box-close')[0]
      const closeCookie = document.getElementsByClassName('optanon-button-allow')[0]
      const closePopup = document.getElementsByClassName('optanon-white-button-middle')[0]
      if (close) {
        close.addEventListener('click', () => {
          document.getElementsByTagName('body')[0].classList.remove('banner-adj')
          document.getElementsByClassName('optanon-alert-box-wrapper')[0].classList.remove('cookieban')
          document.getElementsByClassName('header-wrapper')[0].style.top = `${0}px`
        })
      }
      if (closeCookie) {
        closeCookie.addEventListener('click', () => {
          document.getElementsByTagName('body')[0].classList.remove('banner-adj')
          document.getElementsByClassName('optanon-alert-box-wrapper')[0].classList.remove('cookieban')
          document.getElementsByClassName('header-wrapper')[0].style.top = `${0}px`
        })
      }
      if (closePopup) {
        closePopup.addEventListener('click', () => {
          document.getElementsByTagName('body')[0].classList.remove('banner-adj')
          document.getElementsByClassName('optanon-alert-box-wrapper')[0].classList.remove('cookieban')
          document.getElementsByClassName('header-wrapper')[0].style.top = `${0}px`
        })
      }
    }
  }
  const setInt = setInterval(cookieHeader, Infinity)
})
// blue-outline
const outlineStyles = 'body.is-using-keyboard :focus {outline-offset: -2px;outline: 5px solid #4d90fe!important;}body :focus {outline: 0!important;}'
const styleNode = document.createElement('style')
styleNode.type = 'text/css'
styleNode.innerHTML = outlineStyles
const islfHf = document.getElementsByClassName('lf_hf')[0]
if (islfHf) {
  document.getElementsByTagName('head')[0].appendChild(styleNode)
}
// cookie banner
const cookiestyles = '.cookieban {top: 0 !important; transform: none !important;}'
const cookieNode = document.createElement('style')
cookieNode.type = 'text/css'
cookieNode.innerHTML = cookiestyles
const islfHf1 = document.getElementsByClassName('lf_hf')[0]
if (islfHf1) {
  document.getElementsByTagName('head')[0].appendChild(cookieNode)
}
const cookiestylesbody = 'body {position: absolute; left: 0;right: 0;transform: none !important;}'
const cookieNodebody = document.createElement('style')
cookieNodebody.type = 'text/css'
cookieNodebody.innerHTML = cookiestylesbody
const islfHfbody = document.getElementsByClassName('lf_hf')[0]
if (islfHfbody) {
  document.getElementsByTagName('head')[0].appendChild(cookieNodebody)
}

// Lazy Loading images
document.addEventListener('DOMContentLoaded', function () {
  const lazyImages = [].slice.call(document.querySelectorAll('img.lazy'))
  if ('IntersectionObserver' in window) {
    const lazyImageObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        const lazyImage = entry.target
        lazyImage.src = lazyImage.dataset.src
        lazyImage.srcset = lazyImage.dataset.srcset
        lazyImage.classList.remove('lazy')
        lazyImageObserver.unobserve(lazyImage)
      }
      })
    })

    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage)
    })
  } else {
    // Possibly fall back to a more compatible method here
  }
  //Latam Newsletter dropdown list added
  let hairTypeSelect = document.getElementsByClassName('scfDroplistBorder');
  let hairTypeDropdown = document.querySelector('.scfDroplistBorder > select');
  if(hairTypeSelect.length > 0){
    hairTypeSelect[0].style.display = 'none';

    const matches = document.querySelectorAll('.radio input[type="radio"]');
    const getSelectedValue = (e) => {
      hairTypeDropdown.setAttribute("id", "SelectDropID");
      if (e.target.value == 'Consumidor') {
        hairTypeSelect[0].style.display = 'block';
        hairTypeDropdown[0].value = ''
      } else {
        hairTypeSelect[0].style.display = 'none';
        hairTypeDropdown[0].value = 'none'
      }
    }
    matches.forEach(match => {
      match.addEventListener('click', getSelectedValue);
    });
  }
})
